import React, { Component } from 'react';
import { isEmpty } from 'lodash';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Edit, Delete } from '@mui/icons-material';
import  {
    Typography,
    Button,
    IconButton,
    FormControl,
    Select,
    OutlinedInput,
    FormHelperText,
    FormControlLabel,
    FormLabel,
    Grid,
    InputLabel,
    MenuItem,
    TextField
} from '@mui/material';

import Currency from '../../common/Currency';


class ReceivePayment extends Component {
    state = { }
    
    handleChange = (e) => {
        const { name, value } = e.target;
        const regex = /^([0-9]+([.][0-9]*)?|[.][0-9]+)$/

        if(name === "payment_amount"){
            if(regex.test(value) || value === ""){
                this.props.handleChange(name, parseFloat(value) , this.props.index)
            }
        } else {
            this.props.handleChange(name, value , this.props.index)
        }
    }
        
    render() {
        const { index, SPENDINGS, selected, spending, errors } = this.props;
        console.log("spending:", this.props.spending)
        let background = (index % 2 === 0) ? "" : "#f1f4f7";
        
        return (
            <div>
                <hr/>
                <div style={{background, padding: "15px", marginBottom: "15px" }}>
                    <h6>Dépense {index + 1}</h6>
                    <Grid container spacing={2}>
                        <Grid item sm={6} xs={12}>
                            <FormControl required error={!!errors.payment_spending_id} variant="outlined" style={{ width:'100%'}}>
                                <InputLabel htmlFor="payment_spending_id">Dépense</InputLabel>
                                <Select
                                    value={this.props.payment_spending_id || ""}
                                    onChange={this.handleChange}
                                    input={<OutlinedInput labelWidth={80} name="payment_spending_id" id="payment_spending_id" />}
                                >
                                    <MenuItem value="" />
                                    {Object.values(SPENDINGS).map( item => (
                                        <MenuItem 
                                            value={item.spending_id} 
                                            disabled={selected.includes(item.spending_id)}
                                        >
                                            {new Date(item.spending_date).toLocaleDateString("fr-FR") } - <Currency value={item.spending_amountTTC} />
                                        </MenuItem>

                                    ))}
                                </Select>
                                <FormHelperText >{errors.payment_spending_id}</FormHelperText>
                            </FormControl>
                        </Grid>

                        <Grid item sm={6} xs={12}>
                            <TextField
                                onChange={this.handleChange}
                                required
                                id="payment_amount"
                                error={!!errors.payment_amount}
                                helperText={errors.payment_amount}
                                value={this.props.payment_amount}
                                name="payment_amount"
                                label="Montant"
                                variant="outlined"  
                                type="number"          
                                style={{width:"100%"}}
                    
                            />
                            {spending && 
                                <FormHelperText >Reste à Payer : {spending.spending_rest_to_pay}</FormHelperText>
                            }
                        </Grid>
                    </Grid>

                </div>                
            </div>
        );
    }
}


export default ReceivePayment 